export default {
  "en": {
    "landingTitle": "How would you like to communicate?",
    "landingSubtitle": "Choose your preferred method",
    "voiceCall": "Voice Call",
    "textChat": "Text Chat",
    "clickToStartCall": "Click to Start Call",
    "realTimeVoice": "Real-time voice conversation",
    "startCall": "Start Call",
    "connecting": "Connecting...",
    "connectingSubtitle": "Please wait",
    "awaitingBrowserMic": "Waiting for microphone…",
    "awaitingBrowserMicDetail": "Allow access in your browser’s permission prompt.",
    "listening": "Listening...",
    "speakFreely": "Speak freely",
    "liveTranscript": "Live Transcript",
    "transcriptWillAppear": "Transcript will appear here during the call...",
    "userTranscriptPrefix": "You: ",
    "mute": "Mute",
    "speaker": "Speaker",
    "endCall": "End Call",
    "hello": "Hello! How can I help?",
    "sendMessage": "Send a message to get started",
    "online": "Online",
    "newChat": "New Chat",
    "back": "Back",
    "backToModeChoice": "Voice or text",
    "close": "Close",
    "error": "Error",
    "typeMessage": "Type your message...",
    "sendMessageAria": "Send message",
    "domainNotValidated": "Domain not validated",
    "domainErrorMessage": "This domain is not whitelisted. Please contact the administrator to whitelist your website URL.",
    "aboutTitle": "About",
    "aboutVersion": "SDK version",
    "aboutConversationId": "Last conversation ID",
    "aboutNoConversation": "No conversation yet"
  },
  "he": {
    "landingTitle": "איך תרצה לתקשר?",
    "landingSubtitle": "בחר את השיטה המועדפת עליך",
    "voiceCall": "שיחה קולית",
    "textChat": "צ'אט טקסט",
    "clickToStartCall": "לחץ להתחלת שיחה",
    "realTimeVoice": "שיחה קולית בזמן אמת",
    "startCall": "התחל שיחה",
    "connecting": "מתחבר...",
    "connectingSubtitle": "אנא המתן",
    "awaitingBrowserMic": "ממתין למיקרופון…",
    "awaitingBrowserMicDetail": "אשר גישה בחלון ההרשאות של הדפדפן.",
    "listening": "מקשיב...",
    "speakFreely": "דבר בחופשיות",
    "liveTranscript": "תמלול בזמן אמת",
    "transcriptWillAppear": "התמלול יופיע כאן במהלך השיחה...",
    "userTranscriptPrefix": "אתה: ",
    "mute": "השתק",
    "speaker": "רמקול",
    "endCall": "סיים שיחה",
    "hello": "שלום! איך אפשר לעזור?",
    "sendMessage": "שלח הודעה או עבור למצב קולי לשיחה בזמן אמת",
    "online": "מקוון",
    "newChat": "צ'אט חדש",
    "back": "חזור",
    "backToModeChoice": "קול או טקסט",
    "close": "סגור",
    "error": "שגיאה",
    "typeMessage": "הקלד הודעה...",
    "sendMessageAria": "שלח הודעה",
    "domainNotValidated": "דומיין לא מאומת",
    "domainErrorMessage": "דומיין זה לא ברשימת המורשים. אנא פנה למנהל המערכת כדי להוסיף את כתובת האתר שלך לרשימה.",
    "aboutTitle": "אודות",
    "aboutVersion": "גרסת SDK",
    "aboutConversationId": "מזהה שיחה אחרון",
    "aboutNoConversation": "אין שיחה עדיין"
  },
  "ar": {
    "landingTitle": "كيف تريد التواصل؟",
    "landingSubtitle": "اختر الطريقة المفضلة لديك",
    "voiceCall": "مكالمة صوتية",
    "textChat": "دردشة نصية",
    "clickToStartCall": "انقر لبدء المكالمة",
    "realTimeVoice": "محادثة صوتية في الوقت الفعلي",
    "startCall": "ابدأ المكالمة",
    "connecting": "جارٍ الاتصال...",
    "connectingSubtitle": "يرجى الانتظار",
    "awaitingBrowserMic": "في انتظار الميكروفون…",
    "awaitingBrowserMicDetail": "اسمح بالوصول في موجه أذونات المتصفح.",
    "listening": "الاستماع...",
    "speakFreely": "تكلم بحرية",
    "liveTranscript": "نص مباشر",
    "transcriptWillAppear": "سيظهر النص هنا أثناء المكالمة...",
    "userTranscriptPrefix": "أنت: ",
    "mute": "كتم الصوت",
    "speaker": "مكبر الصوت",
    "endCall": "إنهاء المكالمة",
    "hello": "مرحبا! كيف يمكنني المساعدة؟",
    "sendMessage": "أرسل رسالة للبدء",
    "online": "متصل",
    "newChat": "محادثة جديدة",
    "back": "رجوع",
    "backToModeChoice": "صوت أو نص",
    "close": "إغلاق",
    "error": "خطأ",
    "typeMessage": "اكتب رسالة...",
    "sendMessageAria": "إرسال رسالة",
    "domainNotValidated": "النطاق غير معتمد",
    "domainErrorMessage": "هذا النطاق غير مسموح به. يرجى الاتصال بالمسؤول لإضافة عنوان موقع الويب الخاص بك إلى القائمة.",
    "aboutTitle": "حول",
    "aboutVersion": "إصدار SDK",
    "aboutConversationId": "معرّف آخر محادثة",
    "aboutNoConversation": "لا توجد محادثة بعد"
  },
  "ru": {
    "landingTitle": "Как вы хотите общаться?",
    "landingSubtitle": "Выберите предпочтительный способ",
    "voiceCall": "Голосовой звонок",
    "textChat": "Текстовый чат",
    "clickToStartCall": "Нажмите, чтобы начать звонок",
    "realTimeVoice": "Голосовой разговор в реальном времени",
    "startCall": "Начать звонок",
    "connecting": "Подключение...",
    "connectingSubtitle": "Пожалуйста, подождите",
    "awaitingBrowserMic": "Ожидание микрофона…",
    "awaitingBrowserMicDetail": "Разрешите доступ в запросе браузера.",
    "listening": "Слушаю...",
    "speakFreely": "Говорите свободно",
    "liveTranscript": "Живая транскрипция",
    "transcriptWillAppear": "Транскрипция появится здесь во время звонка...",
    "userTranscriptPrefix": "Вы: ",
    "mute": "Отключить звук",
    "speaker": "Динамик",
    "endCall": "Завершить звонок",
    "hello": "Привет! Как я могу помочь?",
    "sendMessage": "Отправьте сообщение для начала",
    "online": "В сети",
    "newChat": "Новый чат",
    "back": "Назад",
    "backToModeChoice": "Голос или текст",
    "close": "Закрыть",
    "error": "Ошибка",
    "typeMessage": "Введите сообщение...",
    "sendMessageAria": "Отправить сообщение",
    "domainNotValidated": "Домен не проверен",
    "domainErrorMessage": "Этот домен не в белом списке. Пожалуйста, свяжитесь с администратором, чтобы добавить URL вашего веб-сайта в список.",
    "aboutTitle": "О приложении",
    "aboutVersion": "Версия SDK",
    "aboutConversationId": "ID последнего разговора",
    "aboutNoConversation": "Разговоров пока нет"
  },
  "es": {
    "landingTitle": "¿Cómo te gustaría comunicarte?",
    "landingSubtitle": "Elige tu método preferido",
    "voiceCall": "Llamada de voz",
    "textChat": "Chat de texto",
    "clickToStartCall": "Haz clic para iniciar la llamada",
    "realTimeVoice": "Conversación de voz en tiempo real",
    "startCall": "Iniciar llamada",
    "connecting": "Conectando...",
    "connectingSubtitle": "Por favor espere",
    "awaitingBrowserMic": "Esperando el micrófono…",
    "awaitingBrowserMicDetail": "Permita el acceso en el cuadro de permisos del navegador.",
    "listening": "Escuchando...",
    "speakFreely": "Habla libremente",
    "liveTranscript": "Transcripción en vivo",
    "transcriptWillAppear": "La transcripción aparecerá aquí durante la llamada...",
    "userTranscriptPrefix": "Tú: ",
    "mute": "Silenciar",
    "speaker": "Altavoz",
    "endCall": "Terminar llamada",
    "hello": "¡Hola! ¿Cómo puedo ayudarte?",
    "sendMessage": "Envía un mensaje para comenzar",
    "online": "En línea",
    "newChat": "Nuevo chat",
    "back": "Atrás",
    "backToModeChoice": "Voz o texto",
    "close": "Cerrar",
    "error": "Error",
    "typeMessage": "Escribe un mensaje...",
    "sendMessageAria": "Enviar mensaje",
    "domainNotValidated": "Dominio no validado",
    "domainErrorMessage": "Este dominio no está en la lista blanca. Por favor, contacte al administrador para agregar la URL de su sitio web a la lista.",
    "aboutTitle": "Acerca de",
    "aboutVersion": "Versión del SDK",
    "aboutConversationId": "ID de última conversación",
    "aboutNoConversation": "Aún no hay conversación"
  },
  "fr": {
    "landingTitle": "Comment souhaitez-vous communiquer?",
    "landingSubtitle": "Choisissez votre méthode préférée",
    "voiceCall": "Appel vocal",
    "textChat": "Chat texte",
    "clickToStartCall": "Cliquez pour démarrer l'appel",
    "realTimeVoice": "Conversation vocale en temps réel",
    "startCall": "Démarrer l'appel",
    "connecting": "Connexion...",
    "connectingSubtitle": "Veuillez patienter",
    "awaitingBrowserMic": "En attente du microphone…",
    "awaitingBrowserMicDetail": "Autorisez l’accès dans la fenêtre d’autorisation du navigateur.",
    "listening": "Écoute...",
    "speakFreely": "Parlez librement",
    "liveTranscript": "Transcripción en direct",
    "transcriptWillAppear": "La transcription apparaîtra ici pendant l'appel...",
    "userTranscriptPrefix": "Vous : ",
    "mute": "Muet",
    "speaker": "Haut-parleur",
    "endCall": "Terminer l'appel",
    "hello": "Bonjour! Comment puis-je vous aider?",
    "sendMessage": "Envoyez un message pour commencer",
    "online": "En ligne",
    "newChat": "Nouveau chat",
    "back": "Retour",
    "backToModeChoice": "Voix ou texte",
    "close": "Fermer",
    "error": "Erreur",
    "typeMessage": "Tapez votre message...",
    "sendMessageAria": "Envoyer un message",
    "domainNotValidated": "Domaine non validé",
    "domainErrorMessage": "Ce domaine n'est pas sur la liste blanche. Veuillez contacter l'administrateur pour ajouter l'URL de votre site Web à la liste.",
    "aboutTitle": "À propos",
    "aboutVersion": "Version du SDK",
    "aboutConversationId": "ID de la dernière conversation",
    "aboutNoConversation": "Aucune conversation pour l'instant"
  },
  "de": {
    "landingTitle": "Wie möchten Sie kommunizieren?",
    "landingSubtitle": "Wählen Sie Ihre bevorzugte Methode",
    "voiceCall": "Sprachanruf",
    "textChat": "Text-Chat",
    "clickToStartCall": "Klicken Sie, um den Anruf zu starten",
    "realTimeVoice": "Sprachanruf in Echtzeit",
    "startCall": "Anruf starten",
    "connecting": "Verbinden...",
    "connectingSubtitle": "Bitte warten",
    "awaitingBrowserMic": "Warte auf Mikrofon…",
    "awaitingBrowserMicDetail": "Erlauben Sie den Zugriff in der Browser-Anfrage.",
    "listening": "Hören...",
    "speakFreely": "Sprechen Sie frei",
    "liveTranscript": "Live-Transkription",
    "transcriptWillAppear": "Die Transkription erscheint hier während des Anrufs...",
    "userTranscriptPrefix": "Sie: ",
    "mute": "Stumm",
    "speaker": "Lautsprecher",
    "endCall": "Anruf beenden",
    "hello": "Hallo! Wie kann ich helfen?",
    "sendMessage": "Senden Sie eine Nachricht zum Starten",
    "online": "Online",
    "newChat": "Neuer Chat",
    "back": "Zurück",
    "backToModeChoice": "Sprache oder Text",
    "close": "Schließen",
    "error": "Fehler",
    "typeMessage": "Geben Sie eine Nachricht ein...",
    "sendMessageAria": "Nachricht senden",
    "domainNotValidated": "Domain nicht validiert",
    "domainErrorMessage": "Diese Domain steht nicht auf der Whitelist. Bitte kontaktieren Sie den Administrator, um die URL Ihrer Website zur Liste hinzuzufügen.",
    "aboutTitle": "Über",
    "aboutVersion": "SDK-Version",
    "aboutConversationId": "Letzte Konversations-ID",
    "aboutNoConversation": "Noch keine Konversation"
  }
};
